"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useApprovalWaveStatus } from "@/hooks/waves/useApprovalWaveStatus";
import { SingleWaveDropWrapper } from "./SingleWaveDropWrapper";
import { SingleWaveDropInfoPanel } from "./SingleWaveDropInfoPanel";
import { useSingleWaveDropData } from "./useSingleWaveDropData";
interface DefaultSingleWaveDropProps {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
export const DefaultSingleWaveDrop: React.FC<DefaultSingleWaveDropProps> = t0 => {
  const $ = _c(14);
  const {
    drop: initialDrop,
    onClose
  } = t0;
  const {
    drop,
    wave,
    extendedDrop
  } = useSingleWaveDropData(initialDrop, onClose);
  let t1;
  if ($[0] !== wave) {
    t1 = {
      wave
    };
    $[0] = wave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    winningThreshold,
    isVotingClosed,
    isVotingControlsLocked
  } = useApprovalWaveStatus(t1);
  if (!extendedDrop || !wave || !drop) {
    return null;
  }
  let t2;
  if ($[2] !== extendedDrop || $[3] !== isVotingClosed || $[4] !== isVotingControlsLocked) {
    t2 = <SingleWaveDropInfoPanel drop={extendedDrop} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} />;
    $[2] = extendedDrop;
    $[3] = isVotingClosed;
    $[4] = isVotingControlsLocked;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== drop || $[7] !== isVotingClosed || $[8] !== isVotingControlsLocked || $[9] !== onClose || $[10] !== t2 || $[11] !== wave || $[12] !== winningThreshold) {
    t3 = <SingleWaveDropWrapper drop={drop} wave={wave} onClose={onClose} winningThreshold={winningThreshold} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked}>{t2}</SingleWaveDropWrapper>;
    $[6] = drop;
    $[7] = isVotingClosed;
    $[8] = isVotingControlsLocked;
    $[9] = onClose;
    $[10] = t2;
    $[11] = wave;
    $[12] = winningThreshold;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};